import axios from '../../axios/axios';

const ClientService = {

  getAllClients: (pageNumber, pageSize, sortField = 'name', sortOrder = 'dsc', search) => {
    let url = `/clients?page=${pageNumber}&size=${pageSize}&sortBy=${sortField}&sortDirection=${sortOrder}`;
    if (search) {
      url += `&search=${encodeURIComponent(search)}`;
    }
    return axios.get(url, { withCredentials: true });
  },

  exportClients: () => {
    return axios.get('/clients/export', {
      responseType: 'blob'
    })
  },

  getClientById: (clientId) => {
    return axios.get(`/clients/${clientId}`)
  },

  addClient: (name, surname, passportNumber, cardId, dateOfBirth, phoneNumber, email, points, loyaltyStatus, address) =>{
    const newClient = {
      name: name,
      surname: surname,
      passportNumber: passportNumber,
      cardId: cardId,
      dateOfBirth: dateOfBirth,
      phoneNumber: phoneNumber,
      email: email,
      points: points,
      loyaltyStatus: loyaltyStatus,
      address: address
    }
    return axios.post("/clients/add", newClient, {
      headers: {
        'Content-Type': 'application/json',
      }
    })
  },

  updateClient: (id, name, surname, passportNumber, cardId, dateOfBirth, phoneNumber, email, points, loyaltyStatus, address) =>{
    const updatedClient = {
      name: name,
      surname: surname,
      passportNumber: passportNumber,
      cardId: cardId,
      dateOfBirth: dateOfBirth,
      phoneNumber: phoneNumber,
      email: email,
      points: points,
      loyaltyStatus: loyaltyStatus,
      address: address
    }
    return axios.post(`/clients/update/${id}`, updatedClient, {
      headers: {
        'Content-Type': 'application/json',
      }
    })
  },

  deleteClient: (id) =>{
    return axios.delete(`clients/delete/${id}`)
  }

}
export default ClientService